export class CaseDetails {
    ChangeableTC: string;
    StatusWeTC: string;
    StatusEIS: string;
    Activity2TC?: any;
    Activity3TC?: any;
    PolicyNumber: string;
    Condition: string;
    DamageNumber: string;
    InstructionNumber: string;
    DamageDate: Date;
    InputDate: Date;
    DamageLocation: string;
    ImpactAngleTC: string;
    EstimatedDamageAmount: number;
    InsuredAmount: number;
    ExcessAmount: number;
    TotalLossTC: string;
    GuaranteeFundTC: string;
    DeedOfAssignmentTC: string;
    RecoverableTC: string;
    VictimPersonTypeTC: string;
    StandStillTimeTC: string;

    public constructor(init?: Partial<CaseDetails>) {
        Object.assign(this, init);
    }
}
